import { ActionReducerMap, createReducer, on } from '@ngrx/store'
import { Themes } from 'src/app/shared/enums/enums'
import {
  AppState,
  PAGE_INITIAL_STATE,
  PageState,
  THEME_INITIAL_STATE,
  ThemeState,
  USER_INITIAL_STATE,
  UserState,
} from '../states'
import {
  activision_code,
  add,
  admin,
  dark_theme,
  email,
  home,
  library,
  light_theme,
  login,
  network,
  notifications,
  paper_theme,
  search,
  signup,
  store,
  username,
  verification,
} from './actions'

/* ------------------- Counter ------------------- */
const _themeReducer = createReducer(
  THEME_INITIAL_STATE,
  on(dark_theme, state => {
    return {
      ...state,
      name: Themes.DARK,
    }
  }),
  on(light_theme, state => {
    return {
      ...state,
      name: Themes.LIGHT,
    }
  }),
  on(paper_theme, state => {
    return {
      ...state,
      name: Themes.PAPER,
    }
  }),
)

export function themeReducer(state: any, action: any): ThemeState {
  return _themeReducer(state, action)
}

/* ------------------- User ------------------- */
const _userReducer = createReducer(
  USER_INITIAL_STATE,
  on(username, state => {
    return {
      ...state,
      username: 'admin',
    }
  }),
  on(email, (state, action) => {
    return {
      ...state,
      email: action.value,
    }
  }),
  on(activision_code, (state, action) => {
    return {
      ...state,
      activision_code: action.value,
    }
  }),
)

export function userReducer(state: any, action: any): UserState {
  return _userReducer(state, action)
}

/* ------------------- Page ------------------- */
const _pageReducer = createReducer(
  PAGE_INITIAL_STATE,
  on(home, state => {
    return {
      ...state,
      currentPage: 'home',
    }
  }),
  on(admin, state => {
    return {
      ...state,
      currentPage: 'admin',
    }
  }),
  on(library, state => {
    return {
      ...state,
      currentPage: 'library',
    }
  }),
  on(store, state => {
    return {
      ...state,
      currentPage: 'store',
    }
  }),
  on(search, state => {
    return {
      ...state,
      currentPage: 'search',
    }
  }),
  on(network, state => {
    return {
      ...state,
      currentPage: 'network',
    }
  }),
  on(notifications, state => {
    return {
      ...state,
      currentPage: 'notifications',
    }
  }),
  on(add, state => {
    return {
      ...state,
      currentPage: 'add',
    }
  }),
  on(signup, state => {
    return {
      ...state,
      currentPage: 'signup',
    }
  }),
  on(login, state => {
    return {
      ...state,
      currentPage: 'login',
    }
  }),
  on(verification, state => {
    return {
      ...state,
      currentPage: 'verification',
    }
  }),
)

export function pageReducer(state: any, action: any): PageState {
  return _pageReducer(state, action)
}

/* ------------------- App (User,Words,Counter) ------------------- */
export const INITIAL_STATE: AppState = {
  themeState: THEME_INITIAL_STATE,
  userState: USER_INITIAL_STATE,
  pageState: PAGE_INITIAL_STATE,
}

export const reducers: ActionReducerMap<any> = {
  themeR: themeReducer,
  userR: userReducer,
  pageR: pageReducer,
}
